import { render, staticRenderFns } from "./VersionListPage.vue?vue&type=template&id=150e4b31&scoped=true"
import script from "./VersionListPage.vue?vue&type=script&lang=js"
export * from "./VersionListPage.vue?vue&type=script&lang=js"
import style0 from "./VersionListPage.vue?vue&type=style&index=0&id=150e4b31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150e4b31",
  null
  
)

export default component.exports